import React from "react"
import PropTypes from "prop-types"
import {Box} from "@mui/material"
import FormSectionAccordion from "src/v2/components/FormSectionAccordion"
import theme from "src/v2/theme/theme"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"
import { renderGrid } from "src/v2/components/FieldRenderer"
import {caracteristicasFields} from "./constants"

const CaracteristicasSection = ({
    state,
    setSectionField,
    actions,
    defaultOpen = false,
    syncToken = 0,
    autoCompleteController = {},
}) => {
    return (
        <Box sx={{mt: 0}}>
            <FormSectionAccordion
                title="Características"
                icon={<CheckIcon style={{color: theme.palette.icon.main, width: 20, height: 20}} />}
                actions={actions}
                defaultOpen={defaultOpen}
                syncToken={syncToken}
                disableBorder={true}
            >
                {renderGrid(
                    caracteristicasFields,
                    state,
                    (key) => (value) => setSectionField("caracteristicas", key, value),
                    undefined,
                    undefined,
                    (key, value) => setSectionField("caracteristicas", key, value),
                    autoCompleteController
                )}

            </FormSectionAccordion>
        </Box>
    )
}

CaracteristicasSection.propTypes = {
    state: PropTypes.object.isRequired,
    setSectionField: PropTypes.func.isRequired,
    actions: PropTypes.node,
    defaultOpen: PropTypes.bool,
    syncToken: PropTypes.number,
    autoCompleteController: PropTypes.object,
}

export default CaracteristicasSection